import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SatelliteLockType } from 'src/app/core/interfaces/satelliteLockType';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Utils } from 'src/app/core/resources/utils';
import { SatelliteLockService } from 'src/app/modules/satellite-lock/satellite-lock.service';

@Component({
  selector: 'app-autocomplete-satellite-lock-type',
  templateUrl: './autocomplete-satellite-lock-type.component.html',
  styleUrls: ['./autocomplete-satellite-lock-type.component.scss']
})
export class AutocompleteSatelliteLockTypeComponent implements OnInit {

  @Input() options: OptionsAutocomplete;
  @Input() inputFormControl: FormControl;
  @Input() validate: string = '';
  loadingSatelliteLockTypes: boolean = false;

  formControlSatelliteLockType: FormControl = new FormControl();
  listSatelliteLockTypes: SatelliteLockType[] = [];

  constructor(
    private satelliteLockService: SatelliteLockService,
    public utils: Utils
  ) { }

  ngOnInit() {
    const validator = this.inputFormControl && this.inputFormControl.validator ? this.inputFormControl.validator({} as AbstractControl) : '';
    if (validator && validator.required) this.formControlSatelliteLockType.setValidators(Validators.required);
    this.getSatelliteLockTypes();
  }

  async getSatelliteLockTypes() {
    this.loadingSatelliteLockTypes = true;
    let currentSatelliteLockTypeList: SatelliteLockType[] = [];
    try {
      const response = await this.satelliteLockService.getSatelliteLockTypes().toPromise();
      if (response && response.catalog && response.catalog.length) currentSatelliteLockTypeList = response.catalog;
    } catch (error) { }
    this.loadingSatelliteLockTypes = false;
    this.listSatelliteLockTypes = currentSatelliteLockTypeList;
  }

  displaySatelliteLockTypeName(satelliteLockType?: SatelliteLockType | string): string | undefined {
    return satelliteLockType ? typeof satelliteLockType === 'string' ? satelliteLockType : satelliteLockType.name : undefined;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.options && changes.options.currentValue) {
        const currentInitialValue = changes.options.currentValue.initialValue;
        const previousInitialValue = changes.options.previousValue && changes.options.previousValue.initialValue
          ? changes.options.previousValue.initialValue
          : undefined;

        // Solo procesar si el initialValue cambió o es diferente del anterior
        if (currentInitialValue !== previousInitialValue) {
          if (currentInitialValue && currentInitialValue !== '') {
            this.setInitialSatelliteLockType(currentInitialValue);
          } else {
            this.formControlSatelliteLockType.setValue("");
            if (this.inputFormControl) this.inputFormControl.setValue("");
          }
        }
      }

      if (changes.validate) {
        switch (this.validate) {
          case 'touched':
            this.formControlSatelliteLockType.markAsTouched();
            break;
          case 'untouched':
            this.formControlSatelliteLockType.markAsUntouched();
            break;
          case 'enable':
            this.formControlSatelliteLockType.enable();
            break;
          case 'disable':
            this.formControlSatelliteLockType.disable();
            break;
          case 'disable&untouched':
            this.formControlSatelliteLockType.markAsUntouched();
            this.formControlSatelliteLockType.disable();
            break;
          case 'setValidators':
            this.formControlSatelliteLockType.setValidators(Validators.required);
            this.formControlSatelliteLockType.updateValueAndValidity();
            break;
          case 'clearValidators':
            this.formControlSatelliteLockType.clearValidators();
            this.formControlSatelliteLockType.updateValueAndValidity();
            break;
          default:
            break;
        }
      }
    }
  }

  async setInitialSatelliteLockType(idOrName: string) {
    if (!idOrName || idOrName === '') return;
    if (!this.listSatelliteLockTypes.length) await this.getSatelliteLockTypes();
    const satelliteLockType = this.listSatelliteLockTypes.find((type) => {
      const typeId = type.id ? type.id.toString().trim() : '';
      const typeName = type.name ? type.name.toString().trim() : '';
      return typeId === idOrName.toString().trim() || typeName === idOrName.toString().trim();
    });

    if (satelliteLockType) {
      this.formControlSatelliteLockType.setValue(satelliteLockType);
      this.inputFormControl.setValue(satelliteLockType);
    }
  }

  onSelectSatelliteLockType($event: MatAutocompleteSelectedEvent) {
    if ($event && $event.option && $event.option.value && this.inputFormControl) this.inputFormControl.setValue($event.option.value);
  }

  changeValue() {
    if (this.inputFormControl) this.inputFormControl.setValue("");
  }

  get satelliteLockTypesFiltered(): SatelliteLockType[] {
    const value: SatelliteLockType | string = this.formControlSatelliteLockType.value
    if (!value) return this.listSatelliteLockTypes;
    const term = typeof value === 'string' ? value : value.name;
    return this.listSatelliteLockTypes.filter(type => type && type.name &&
      type.name.toLowerCase().includes(term.toLowerCase())
    );
  }
}
